import { render, staticRenderFns } from "./ImageUploader.vue?vue&type=template&id=a508b3fa&"
import script from "./ImageUploaderVue.ts?vue&type=script&lang=ts&"
export * from "./ImageUploaderVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports